// src/lib/consent.js
//
// A süti-hozzájárulás egyetlen igazságforrása. A CookieBanner ezt használja,
// és bárhonnan (pl. lábléc-link) újranyitható vele a döntés.

export const CONSENT_KEY = "cookie-consent"; // accepted | rejected
export const CONSENT_CHANGED_EVENT = "cookie-consent-changed";

export const ACCEPTED = "accepted";
export const REJECTED = "rejected";

// A Google és a Microsoft mérési sütijei – visszavonáskor ezeket töröljük
const TRACKING_COOKIE_PREFIXES = [
  "_ga",
  "_gid",
  "_gat",
  "_gcl",
  "_clck",
  "_clsk",
  "CLID",
  "ANONCHK",
  "_fbp",
  "_fbc",
  "fr",
  "MR",
  "MUID",
  "SM",
];

export function getConsent() {
  if (typeof window === "undefined") return null;
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch (e) {
    // letiltott tárolás / privát mód
    return null;
  }
}

function notify() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(CONSENT_CHANGED_EVENT));
}

export function setConsent(value) {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch (e) {
    // ha nem tudjuk elmenteni, a banner legközelebb újra megkérdezi
  }
  notify();
}

// A döntés törlése – a banner újra megjelenik
export function resetConsent() {
  try {
    localStorage.removeItem(CONSENT_KEY);
  } catch (e) {
    // nincs teendő
  }
  notify();
}

// Fut-e már mérési script ezen az oldalbetöltésen? Azért kell, mert a döntés
// törlése (resetConsent) után a tárolt érték már nem árulja el, hogy a
// scriptek korábban betöltődtek-e.
export function trackingActive() {
  if (typeof window === "undefined") return false;
  return (
    typeof window.gtag === "function" ||
    typeof window.clarity === "function" ||
    typeof window.fbq === "function"
  );
}

// Már kitett mérési sütik törlése (visszavonáskor)
export function clearTrackingCookies() {
  if (typeof document === "undefined") return;

  const host = window.location.hostname;
  // pl. "app.pelda.hu" -> ["app.pelda.hu", ".app.pelda.hu", ".pelda.hu"]
  const domains = [undefined, host, `.${host}`];
  const parts = host.split(".");
  if (parts.length > 2) domains.push(`.${parts.slice(-2).join(".")}`);

  document.cookie.split(";").forEach((entry) => {
    const name = entry.split("=")[0].trim();
    if (!name) return;
    if (!TRACKING_COOKIE_PREFIXES.some((prefix) => name.startsWith(prefix))) {
      return;
    }
    domains.forEach((domain) => {
      document.cookie =
        `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/` +
        (domain ? `; domain=${domain}` : "");
    });
  });
}
